import React from "react";

const CheckMarkCircleGreen13 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    {...props}
  >
    <path
      d="M6.5 1.125C5.53582 1.125 4.59329 1.41091 3.7916 1.94659C2.98991 2.48226 2.36507 3.24363 1.99609 4.13442C1.62711 5.02521 1.53057 6.00541 1.71867 6.95107C1.90678 7.89672 2.37108 8.76536 3.05286 9.44715C3.73464 10.1289 4.60328 10.5932 5.54894 10.7813C6.49459 10.9694 7.47479 10.8729 8.36558 10.5039C9.25637 10.1349 10.0177 9.51009 10.5534 8.7084C11.0891 7.90671 11.375 6.96418 11.375 6C11.3736 4.70749 10.8596 3.46831 9.94564 2.55436C9.0317 1.64042 7.79251 1.12636 6.5 1.125ZM8.64031 5.14031L6.01531 7.76531C5.98049 7.80018 5.93913 7.82784 5.8936 7.84671C5.84808 7.86558 5.79928 7.87529 5.75 7.87529C5.70072 7.87529 5.65192 7.86558 5.6064 7.84671C5.56088 7.82784 5.51952 7.80018 5.48469 7.76531L4.35969 6.64031C4.28932 6.56995 4.24979 6.47451 4.24979 6.375C4.24979 6.27549 4.28932 6.18005 4.35969 6.10969C4.43005 6.03932 4.52549 5.99979 4.625 5.99979C4.72451 5.99979 4.81995 6.03932 4.89031 6.10969L5.75 6.96984L8.10969 4.60969C8.14453 4.57485 8.18589 4.54721 8.23142 4.52835C8.27694 4.5095 8.32573 4.49979 8.375 4.49979C8.42428 4.49979 8.47307 4.5095 8.51859 4.52835C8.56411 4.54721 8.60547 4.57485 8.64031 4.60969C8.67516 4.64453 8.70279 4.68589 8.72165 4.73141C8.74051 4.77694 8.75021 4.82573 8.75021 4.875C8.75021 4.92427 8.74051 4.97306 8.72165 5.01859C8.70279 5.06411 8.67516 5.10547 8.64031 5.14031Z"
      fill="#37B450"
    />
  </svg>
);

export default CheckMarkCircleGreen13;
